import { isEditing } from "@builder.io/sdk-react";

import { getBuilderChildrenCount } from "@/libs/builder/utils/getBuilderChildrenCount";

import { Placeholder } from "../Placeholder/Placeholder";

import type { ColumnProps } from "./Column.builder";

export const Column = ({ children }: ColumnProps) => {
  if (getBuilderChildrenCount(children) === 0 && isEditing()) {
    return <Placeholder>Drag and drop components here</Placeholder>;
  }

  return children;
};
